import { sample } from 'effector';

import { getAllCategoriesQuery } from '@/shared/api/catalog/api';
import { pagesPath } from '@/shared/config/$path';
import { declarePage } from '@/shared/lib/effector/page';

export const catalogPage = declarePage({
  pageType: pagesPath.$url().pathname,
});

sample({
  clock: catalogPage.open,
  target: getAllCategoriesQuery.refresh,
});
